import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { ThemeProvider } from 'styled-components';
import moment from 'moment';


const tipos = [
    {label:'Todos'                 , value:'4'},
    {label:'Lavar/Passar'            , value:'1'},
    {label:'Lavar'                  , value:'2'},
    {label:'Passar'                 , value:'3'},
    
]

class separacao extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listarTipos:[],
            tiposDefault: [],
            funcionarios:[],
            funcionario:'',
            gruposServico:[],
            grupoServico:'',
            tipo:'',
            tipoProducao:'',
            pedidosSeparacao:[],
            pedidosSeparados:[],
            itensSeparados: 0,
            itensLavarPassar:0,
            itensPassar:0,
            itensLavar:0,
            itens: [],
            itensSelecionados: new Object(),
            itensProducao:[],
            itensSeparadosProducao:[],
            producao:[],
            itensProducao:[],
            entrega:'',
            isLoading: false
        }

        this.buscar = this.buscar.bind(this)
        this.producao = this.producao.bind(this)
        this.adicionar = this.adicionar.bind(this)
        this.limpar = this.limpar.bind(this)
        this.excluir = this.excluir.bind(this)
        this.separar = this.separar.bind(this)
        this.reiniciar = this.reiniciar.bind(this)
        this.visualizar = this.visualizar.bind(this)
    }

    async Loading( isLoading) {
        this.setState({ isLoading: isLoading});
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo'); 
        
        this.Loading(true);

        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
        });       

        const empresaSeparacao        = permissoes.data.filter(function(value){ return value.idmenu  == 6  })
        if( !empresaSeparacao.length && empresaSeparacao[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 


        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 

        const listarGrupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 
        
        const listarVendas = await api.get('/api/vendas', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        })

        //const pedidosSeparacao = await listarVendas.data.filter(function(value){ return value.status == 3 })

        const atendentes = [];
        listarPessoas.data.forEach(element => {
            if( element.tipo != 1 ) {
                atendentes.push({value: element.id, label:element.razao });           
            }
        });

        const gruposServicos = [{value:99999, label: 'Todas'}]
        listarGrupos.data.forEach(element => {
            gruposServicos.push({value: element.id, label:element.nome });
        });
        this.Loading(false);
        this.setState({
            listatipos: tipos,
            tiposDefault: [tipos[0]],
            funcionarios: atendentes,
            gruposServico: gruposServicos,
            pedidosSeparacao:[],
            itens:[],
            itensSeparados:0,
            itensSelecionados:new Object(),
            producao:[],
            itensProducao:[],
            entrega:''
        })      
    }

    buscar = async() =>  {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo'); 
        this.Loading(true);
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        });       

        const empresaSeparacao        = permissoes.data.filter(function(value){ return value.idmenu  == 6  })
        if( empresaSeparacao.length > 0 && empresaSeparacao[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.')

        

        const body = {
            tipo: this.state.tipo,
            grupo: this.state.grupoServico
        }

        const listarVendas = await api.post('api/separacao', body, {
            headers: {
                'x-access-token':token,
            }
        })      
       
        this.Loading(false);
        this.setState({
            pedidosSeparacao:listarVendas.data,
            pedidosSeparados:[],
            itens:[],
            itensSeparados:0,
            itensSelecionados:new Object(),
        })      
    }

    adicionar = async( id, tipo ) =>  {
        const grupo     = sessionStorage.getItem('grupo');
        const token    = sessionStorage.getItem('token');
        this.Loading(true);

        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
        });       

        const empresaSeparacao        = permissoes.data.filter(function(value){ return value.idmenu  == 6  })
        if( empresaSeparacao.length > 0 && empresaSeparacao[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.')

            
        const itensDePedidos = await api.patch(`/api/vendas/itens/${id}`, null, {
            headers: {
                'x-access-token':token,
            }
        })

        console.log(itensDePedidos)
        const itens = await itensDePedidos.data.filter(function(value){ return value.cupom == 1 })
        
        const itensLavarPassar = await itensDePedidos.data.filter(function(value){ return value && value.tipo == 1 && value.cupom == 1})
        const itensLavar = await itensDePedidos.data.filter(function(value){ return value && value.tipo == 2 && value.cupom == 1 })
        const itensPassar = await itensDePedidos.data.filter(function(value){ return value && value.tipo == 3 && value.cupom == 1 })

        const itensSelecionados = this.state.itensSelecionados ? this.state.itensSelecionados : new Object();
        const pedidosSeparados = this.state.pedidosSeparados.length ? this.state.pedidosSeparados  : []
        
        let lavarPassar = 0;
        let lavar = 0;
        let passar = 0;


        if(itens.length) {

            if( !itensSelecionados[id] ) {
                itensSelecionados[id] = itens
                pedidosSeparados.push(id)
            }

            
            for (let index = 0; index < itensLavarPassar.length; index++) {
                const item = itensLavarPassar[index];
                lavarPassar += item.quantidade
            }

            for (let index = 0; index < itensLavar.length; index++) {
                const item = itensLavar[index];
                lavar += item.quantidade
            }

            for (let index = 0; index < itensPassar.length; index++) {
                const item = itensPassar[index];
                passar += item.quantidade
            }
    
            
            let itensSeparados = 0
            const itensPedidos = new Object();
            for (const key in itensSelecionados) {
                const itens = itensSelecionados[key];
                for (let index = 0; index < itens.length; index++) {
                    const item = itens[index];
                    
                    if(!itensPedidos[item.idservico]) {
                        itensPedidos[item.idservico] = { id:item.idservico, nome: item.nome, grupo: item.nmgrupo, quantidade: item.quantidade, tipo: item.tipo }
                    } else {
                        itensPedidos[item.idservico].quantidade = itensPedidos[item.idservico].quantidade + item.quantidade;
                    }  
                    
                    
                }               
            }
          
            const itensSelecionadosDoPedido =  []
            for (const key in itensPedidos) {
                const element = itensPedidos[key];
                if(element.quantidade > 0) {
                    itensSelecionadosDoPedido.push(element)
                    itensSeparados += Number(element.quantidade)  
                }
            }
            this.Loading(false);
            this.setState({
                itens:itensSelecionadosDoPedido,
                itensSelecionados:itensSelecionados,
                pedidosSeparados:pedidosSeparados,
                itensSeparados:itensSeparados,
                itensLavarPassar: this.state.itensLavarPassar + lavarPassar,
                itensLavar:this.state.itensLavar + lavar,
                itensPassar: this.state.itensPassar + passar
            })      
        } else {
            this.Loading(false);
            toast.error(`O pedido  não possui item de ${ tipo == 1 ? 'Lavar/Passar' : tipo == 2 ? 'Lavar' : 'Passar'}`)
        }
    } 

    limpar = async() =>  {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo'); 
        this.Loading(true);
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        })  

        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 

        const listarGrupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 
        
        const listarVendas = await api.get('/api/vendas', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        })

        const pedidosSeparacao = await listarVendas.data.filter(function(value){ return value.status  == 3 })

        const atendentes = [];
        listarPessoas.data.forEach(element => {
            if( element.tipo != 1 ) {
                atendentes.push({value: element.id, label:element.razao });           
            }
        });

        const gruposServicos = [{value:99999, label: 'Todas'}]
        listarGrupos.data.forEach(element => {
            gruposServicos.push({value: element.id, label:element.nome });
        });
        this.Loading(false);
        this.setState({
            listatipos: tipos,
            tiposDefault: [tipos[0]],
            funcionarios: atendentes,
            gruposServico: gruposServicos,
            pedidosSeparacao:[],
            pedidosSeparados:[],
            itens:[],
            itensSeparados:0,
            itensPedidos:[],
            itensSelecionados:new Object()
        })      

    }

    excluir = async( id ) =>  {
        this.Loading(true);
        const novoItensSelecionados = new Object();
        const itensSelecionados = this.state.itensSelecionados ? this.state.itensSelecionados : new Object();
        const itensPedidos = this.state.itensSelecionados ? this.state.itensSelecionados : new Object();
        for (const key in itensSelecionados) {
            if(Number(key) != Number(id)) {

                const itens = itensSelecionados[key];
                for (let index = 0; index < itens.length; index++) {
                    const item = itens[index];
                    if(!itensPedidos[item.idservico]) {
                        itensPedidos[item.idservico] = { id:item.idservico, nome: item.nome, grupo: item.nmgrupo, quantidade: item.quantidade, tipo: item.tipo }
                    } else {
                        itensPedidos[item.idservico].quantidade = itensPedidos[item.idservico].quantidade + item.quantidade;
                    }
                    
                }               
            }
        }
        this.Loading(false);
        this.setState({
            itens:[],
            itensPedidos:[],
            pedidosSeparados:[],
            itensSelecionados:novoItensSelecionados
        })
    } 

    producao = async() => {

        const grupo     = sessionStorage.getItem('grupo');
        const token    = sessionStorage.getItem('token');
        this.Loading(true);
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
        });       

        const empresaSeparacao        = permissoes.data.filter(function(value){ return value.idmenu  == 6  })
        if( empresaSeparacao.length > 0 && empresaSeparacao[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.')


        const itensSelecionados = this.state.itensSelecionados ? this.state.itensSelecionados : new Object();
        const itensPedidos = this.state.itensSelecionados ? this.state.itensSelecionados : new Object();
 
        const funcionarios = await api.get(`/api/pessoa/${this.state.funcionario}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 

        const hoje = new Date();
        const producao = this.state.producao.length ? this.state.producao : [];
        const itensProducao = this.state.itensProducao.length ? this.state.itensProducao : [];
        
        const numeroProducao = moment(hoje).format('MMDDHHmmss')
        producao.push({
            id: '',
            status: 1, /* Pendente */
            numero: numeroProducao,
            responsavel: this.state.funcionario,
            responsavelnome: funcionarios.data.fantasia,
            emissao:moment(hoje).format('YYYY-MM-DD'),
            emissaoh:moment(hoje).format('HH:mm'),
            entrega:moment(this.state.entrega).format('YYYY-MM-DD'),
            qtdPedido: this.state.pedidosSeparados.length,
            qtdItem:this.state.itensSeparados,
            tipo: this.state.tipo == 1 || this.state.tipo == 2 ? 2 : 3,
        });

        for (const key in itensSelecionados) {
            const itens = itensSelecionados[key];
            const pedido = this.state.pedidosSeparacao.filter(function(value){ return value.id == key })      
     
            for (let index = 0; index < itens.length; index++) {
                const item = itens[index];
      
                itensProducao.push({
                    id:'',
                    status:1, /* Pedente */
                    pedido: pedido[0].numero,
                    ordemservico: key,
                    ordemservicoitem:item.id,
                    cliente: pedido[0].idcliente,
                    produto: item.nome,
                    servico: item.idservico,
                    quantidade: item.quantidade,
                    tipo: item.tipo,
                    producao:numeroProducao
                })
                
            }
        }

       
        const listarGrupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 
        
        const listarVendas = await api.get('/api/vendas', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        })


        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 
      

        const pedidosSeparacao = await listarVendas.data.filter(function(value){ return value.status  == 3 })

        const atendentes = [];
        listarPessoas.data.forEach(element => {
            if( element.tipo != 1 ) {
                atendentes.push({value: element.id, label:element.razao });           
            }
        });

        const gruposServicos = [{value:99999, label: 'Todas'}]
        listarGrupos.data.forEach(element => {
            gruposServicos.push({value: element.id, label:element.nome });
        });
        this.Loading(false);
        this.setState({
            listatipos: tipos,
            tiposDefault: [tipos[0]],
            funcionarios: atendentes,
            gruposServico: gruposServicos,
            pedidosSeparacao:[],
            pedidosSeparados:[],
            itens:[],
            itensSeparados:0,
            itensPedidos:[],
            itensSelecionados:new Object(),
            producao:producao,
            itensProducao: itensProducao
        })      
    }

    reiniciar = async() => {

        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo'); 
        this.Loading(true);
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        })  

        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 

        const listarGrupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 
        
        const listarVendas = await api.get('/api/vendas', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        })

        const pedidosSeparacao = await listarVendas.data.filter(function(value){ return value.status == 3 })

        console.log(pedidosSeparacao)
        const atendentes = [];
        listarPessoas.data.forEach(element => {
            if( element.tipo != 1 ) {
                atendentes.push({value: element.id, label:element.razao });           
            }
        });

        const gruposServicos = [{value:99999, label: 'Todas'}]
        listarGrupos.data.forEach(element => {
            gruposServicos.push({value: element.id, label:element.nome });
        });
        this.Loading(false);
        this.setState({
            listatipos: tipos,
            tiposDefault: [tipos[0]],
            funcionarios: atendentes,
            gruposServico: gruposServicos,
            pedidosSeparacao:[],
            itens:[],
            itensSeparados:0,
            itensSelecionados:new Object(),
            producao:[],
            itensProducao:[],
            entrega:''
        }) 
    }

    visualizar = async( numero ) => {
        const itens = this.state.itensProducao 
        console.log('itens', itens)
        this.Loading(true);
        const visualizaItens = itens.filter(function(value){ return value.producao == numero && value.cumom == 1 })
        this.Loading(false);
        this.setState({
            itensSeparadosProducao: visualizaItens
        })  
    }

    separar = async( numero ) => {

        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo'); 
        this.Loading(true);
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
        });       

        const empresaSeparacao        = permissoes.data.filter(function(value){ return value.idmenu  == 6  })
        if( empresaSeparacao.length > 0 && empresaSeparacao[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.')

        
        const data = {
            producao: this.state.producao , 
            itens: this.state.itensProducao
        }
        console.log('this.state.itensProducao', this.state.itensProducao)

        await api.post('/api/separacao/separar', data, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
            toast.error(e)
        });

        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 

        const listarGrupos = await api.get('/api/gruposervico', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 
        
                    
        const atendentes = [];
        listarPessoas.data.forEach(element => {
            if( element.tipo != 1 ) {
                atendentes.push({value: element.id, label:element.razao });           
            }
        });

        const gruposServicos = [{value:99999, label: 'Todas'}]
        listarGrupos.data.forEach(element => {
            gruposServicos.push({value: element.id, label:element.nome });
        });
        
        toast.success('Separação realizado com sucesso!')
        this.Loading(false);
        this.setState({
            listatipos: tipos,
            tiposDefault: [tipos[0]],
            funcionarios: atendentes,
            gruposServico: gruposServicos,
            pedidosSeparacao:[],
            itens:[],
            itensSeparados:0,
            itensSelecionados:new Object(),
            producao:[],
            itensProducao:[],
            entrega:''
        }) 
    }

    render() {
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Separação Produção</h3>

                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 col-md-12 col-lg-6 order-1 order-md-1">                                    
                                        <div class="row">  
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label>Grupo</label>
                                                    <Select
                                                        id="grupo"
                                                        placeholder="Selecione" 
                                                        isSearchable="true"
                                                        isOptionSelected   
                                                        isDisabled={ this.state.pedidosSeparacao.length > 0 ||  this.state.producao.length > 0 }
                                                        options={this.state.gruposServico}  
                                                        onChange={ e => this.setState({grupoServico: e.value}) }                                                                                    
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <label>Tipo:</label>
                                                    <Select
                                                        id="tipo"
                                                        placeholder="Selecione" 
                                                        isSearchable="true"
                                                        isOptionSelected 
                                                        clearValue="true"   
                                                        isDisabled={ this.state.pedidosSeparacao.length > 0 ||  this.state.producao.length > 0 }
                                                        options={this.state.listatipos}  
                                                        onChange={ e => this.setState({tipo: e.value}) }                                           
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <label>Ação:</label>                                            
                                                    <button type="button" class={ this.state.grupoServico  &&  ( !this.state.pedidosSeparacao.length &&  !this.state.producao.length ) ? "btn btn-block bg-gradient-primary" : "btn btn-block bg-gradient-primary disabled"} onClick={e => this.state.grupoServico && ( !this.state.pedidosSeparacao.length && !this.state.producao.length  ) ? this.buscar() : {} }>Buscar</button>
                                                </div>
                                            </div>
                                            <br/><br/><br/><br/>
                                            <table class="table table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Data</th>
                                                        <th>Prioridade</th>
                                                        <th>Número</th>
                                                        <th>Cliente</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.pedidosSeparacao.map( (pedido) => 
                                                            <tr key={pedido.id}>
                                                                <td class="jsgrid-cell jsgrid-align-center">
                                                                    {
                                                                        this.state.itensSelecionados[pedido.id] ?
                                                                        <input type="checkbox" onClick={ e =>{ this.excluir(pedido.id)}} checked/> :
                                                                        <input type="checkbox" onClick={ e =>{ this.adicionar(pedido.id, this.state.tipo)}}/> 
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                       pedido.emissao ? moment(pedido.emissao).format('DD/MM/yy') : ''
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {   
                                                                        pedido.nivel === 1 ?  
                                                                        <a href="#" class="nav-link">
                                                                            <i class="fas fa-circle text-primary"></i> NORMAL
                                                                        </a> : pedido.nivel === 2 ?  
                                                                        <a href="#" class="nav-link">
                                                                            <i class="fas fa-circle text-warning"></i> MÉDIA
                                                                        </a> :  
                                                                        <a href="#" class="nav-link">
                                                                            <i class="fas fa-circle text-danger"></i> ALTA
                                                                        </a>

                                                                    }                                                                
                                                                </td>
                                                                <td>{ pedido.numero }</td>
                                                                <td>{ pedido.cliente }</td>
                                                                <td>R$ { pedido.total ? pedido.total.toFixed(2) : 0 }</td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                                
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-6 order-2 order-md-2">
                                        <div class="row">
                                            <div class="col-12 col-sm-2">
                                                <div class="info-box bg-light">
                                                    <div class="info-box-content">
                                                        <span class="info-box-text text-center text-muted">Total Pedidos</span>
                                                        <span class="info-box-number text-center text-muted mb-0">{ this.state.pedidosSeparacao.length }</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-2">
                                                <div class="info-box bg-light">
                                                    <div class="info-box-content">
                                                        <span class="info-box-text text-center text-muted">Em Separação</span>
                                                        <span class="info-box-number text-center text-muted mb-0">{ this.state.pedidosSeparados.length}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-2">
                                                <div class="info-box bg-light">
                                                    <div class="info-box-content">
                                                        <span class="info-box-text text-center text-muted">Separados</span>
                                                        <span class="info-box-number text-center text-muted mb-0">{ this.state.itensSeparados}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-2">
                                                <div class="info-box bg-light">
                                                    <div class="info-box-content">
                                                        <span class="info-box-text text-center text-muted">Lavar/Passar</span>
                                                        <span class="info-box-number text-center text-muted mb-0">{ this.state.itensLavarPassar}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-2">
                                                <div class="info-box bg-light">
                                                    <div class="info-box-content">
                                                        <span class="info-box-text text-center text-muted">Lavar</span>
                                                        <span class="info-box-number text-center text-muted mb-0">{ this.state.itensLavar}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-2">
                                                <div class="info-box bg-light">
                                                    <div class="info-box-content">
                                                        <span class="info-box-text text-center text-muted">Passar</span>
                                                        <span class="info-box-number text-center text-muted mb-0">{ this.state.itensPassar}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">                                                
                                                <table class="table table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Grupo</th>
                                                            <th>Produto</th>
                                                            <th>Quantidade</th>
                                                            <th>Tipo</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.itens.map( (item) => 
                                                                <tr key={item.id}>
                                                                    <td>{ item.id }</td>
                                                                    <td>{ item.grupo }</td>
                                                                    <td>{ item.nome }</td>
                                                                    <td>{ item.quantidade }</td>
                                                                    <td>{ item.tipo === 1 ? 'Lavar/Passar' : item.tipo === 2 ? 'Lavar' : 'Passar' }</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>  
                                </div>   
                                <div class="row">
                                    <div class="col-12">
                                        <div class="card-footer">
                                            <button type="submit" 
                                                class="btn btn-info" 
                                                data-toggle="modal" 
                                                data-target={ this.state.itens.length > 0 ? "#modal-producao" : ""} disabled={ this.state.itens.length ? false : true}>Adicionar</button>
                                            <button type="submit" class="btn btn-danger float-right" onClick={ e => this.limpar()} disabled={ this.state.itens.length ? false : true}>Limpar</button>
                                        </div>
                                    </div>
                                    <div class="modal fade" id="modal-producao">
                                        <div class="modal-dialog modal-sm">
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <h4 class="modal-title">Produção</h4>
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div class="modal-body">
                                                    
                                                    <div class="form-group">
                                                        <label>Responsável</label>
                                                        <Select
                                                            id="prioridade"
                                                            placeholder="Selecione" 
                                                            options={this.state.funcionarios}  
                                                            onChange={ e => this.setState({funcionario: e.value}) }                                                             
                                                        />
                                                    </div>     
                                                    <div class="form-group">
                                                        <label>Data Entrega</label>
                                                        <input type="date" 
                                                            id='dataentrega' 
                                                            name='dataentrega' 
                                                            class="form-control" 
                                                            placeholder="Informe data de entrega" 
                                                            value={ this.state.entrega } 
                                                            onChange={ e => this.setState({ entrega: e.target.value})} />
                                                    </div>                                                     
                                                </div>
                                                <div class="modal-footer justify-content-between">
                                                    <button type="button" class="btn btn-success" data-dismiss="modal" onClick={ e => this.producao()}>Gravar</button>
                                                    <button type="button" class="btn btn-danger" data-dismiss="modal">Abortar</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                           
                                </div>                                 
                                <div class="row">
                                    <div class="col-12">
                                        <table class="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Número</th>
                                                    <th>Responsável</th>
                                                    <th>Emissão</th>
                                                    <th>Entrega</th>
                                                    <th>Qtd Pedido</th>
                                                    <th>Qtd Item</th>
                                                    <th>Tipo</th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.producao.map( (producao) => 
                                                        <tr key={producao.numero}>
                                                            <td>{ producao.numero }</td>
                                                            <td>{ producao.responsavelnome }</td>
                                                            <td>{ producao.emissao }</td>
                                                            <td>{ producao.entrega }</td>
                                                            <td>{ producao.qtdPedido }</td>
                                                            <td>{ producao.qtdItem }</td>                                                            
                                                            <td>{ producao.tipo == 2 ? 'Lavar' : 'Passar' }</td>
                                                            <td>
                                                                <a href="#" onClick={ () => this.visualizar(producao.numero)} data-toggle="modal" data-target="#modal-itens-separados"><i class="far fa-eye"></i></a>
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table> 
                                        <div class="modal-footer justify-content-between">
                                            <button type="button" class="btn btn-success" disabled={  this.state.producao.length ? false : true } onClick={ e => this.state.producao.length ? this.separar() : {} }>Realizar Separação</button>
                                            <button type="button" class="btn btn-danger" onClick={ e => this.reiniciar() }>Reiniciar</button>
                                        </div>                                   
                                    </div>                                  
                                </div>
                                 
                                <div class="modal fade" id="modal-itens-separados">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h4 class="modal-title">Itens Separados</h4>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <DataTable
                                                    title="Listar"
                                                    columns={[
                                                        
                                                        {
                                                            name: 'Número',
                                                            selector: 'producao',
                                                            sortable: true,                                                            
                                                        },

                                                        {
                                                            name: 'Item',
                                                            selector: 'produto',
                                                            sortable: true,                                                            
                                                        },
                                                        {
                                                            name: 'Qtd',
                                                            selector: 'quantidade',
                                                            sortable: true,                                                            
                                                        },
                                                        {
                                                            name: 'Tipo',
                                                            selector: 'tipo',
                                                            sortable: true,
                                                            cell: row => row.tipo == 2 ? 'Lavar' : 'Passar'

                                                        }
                                                    ]}
                                                    data={this.state.itensSeparadosProducao}
                                                    dense="false"
                                                    noHeader="false"                                                  
                                                    pagination                                          
                                                />
                                            </div>
                                            <div class="modal-footer justify-content-between">
                                                <button type="button" class="btn btn-primary" data-dismiss="modal">Fechar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            { 
                                this.state.isLoading ?
                                <div class="overlay d-flex justify-content-center align-items-center">
                                    <i class="fas fa-2x fa-sync fa-spin"></i>
                                </div> : ''
                            }
                        </div>
                    </section>
                </div>
            </div> 
        );
    }

}


export default separacao;